import {texture} from "p3";
import NPC from "./NPC";
import definitions from "../../../definitions";
import GameScene from "../../../scenes/GameScene";

export default class NPCGiantChick extends NPC {
    constructor() {
        super(definitions.NPC_ID.CHICK_OF_DOOM);
        
        this._moved = false;
        this.collisionRadius = 100;
        this.collisionOffsetX = 5;
        this.collisionOffsetY = -80;
        this.turnToFacePlayer = false;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("boss_chick_of_doom_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 0.8, new PIXI.Point(0, -10));
        this.animateIdle(1);

        if(GameScene.active.questManager.isQuestComplete('quest_1', 'chick_of_doom')) {
            this.moveToDefeatedPosition();
        }
    }

    moveToDefeatedPosition() {
        if (this._moved) {
            return;
        }

        this._moved = true;
        this.x += 350;
        this.y += 100;
        this.scale.x = -1;
    }

    onViewAdded() {
        super.onViewAdded();
    }
}